export const OTP_THROTTLING_REASONS: ReadonlySet<string> = new Set([
  'TOO_MANY_REQUESTS',
  'TMRM',
  'THROTTLED',
]);

export const HTTP_STATUS_TOO_MANY_REQUESTS = 429;
